export const specialistFeedbacksItemTtitle = [
    "Identifier",
    "details",
    "assessment",
    "actions",
];

export const sizeItemOnPage = 6;
